import React from 'react';
import { Link } from 'react-router-dom';

const CookiePolicyPage = () => {
  const lastUpdated = 'May 27, 2026';

  return (
    <div className="min-h-screen bg-black text-gray-300">
      <div className="bg-gradient-to-b from-purple-500/10 to-transparent pt-24 pb-12">
        <div className="max-w-4xl mx-auto px-6">
          <Link to="/" className="text-primary-400 hover:text-primary-300 text-sm mb-4 inline-flex items-center gap-2">
            ← Back to Home
          </Link>
          <h1 className="text-4xl md:text-5xl font-gaming font-bold text-white mt-4">Cookie Policy</h1>
          <p className="text-gray-500 mt-4">Last updated: {lastUpdated}</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 pb-24">
        <div className="prose prose-invert prose-lg max-w-none space-y-10">

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">1. About Cookies</h2>
            <p>Cookies are small text files stored on your device when you visit a website. This policy explains how Riven Byte Studios uses cookies on our website (rivenbyte.com).</p>
            <div className="bg-white/5 rounded-xl p-5 mt-4 border border-white/10">
              <p className="text-sm text-yellow-400 font-semibold">Note about our mobile Apps</p>
              <p className="text-sm mt-2">Our mobile games and applications do not use cookies. They store data locally using device-native storage (SharedPreferences, SQLite). This Cookie Policy applies only to our website.</p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">2. Cookies We Use</h2>

            <div className="space-y-4 mt-4">
              <div className="bg-white/5 rounded-xl p-5 border border-white/10">
                <h4 className="text-white font-bold">Essential Cookies</h4>
                <p className="text-sm mt-2">Required for the website to function. These cannot be disabled.</p>
                <p className="text-xs text-gray-500 mt-1">Examples: session management, security tokens</p>
              </div>

              <div className="bg-white/5 rounded-xl p-5 border border-white/10">
                <h4 className="text-white font-bold">Analytics Cookies</h4>
                <p className="text-sm mt-2">Help us understand how visitors use our website. We may use Cloudflare Web Analytics, which is privacy-focused and does not use cookies that track individual users across sites.</p>
              </div>

              <div className="bg-white/5 rounded-xl p-5 border border-white/10">
                <h4 className="text-white font-bold">Third-Party Cookies</h4>
                <p className="text-sm mt-2">Embedded content (such as YouTube videos or social media widgets) may set their own cookies. We do not control these cookies.</p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">3. Managing Cookies</h2>
            <p>You can control cookies through your browser settings. Most browsers allow you to block or delete cookies. Note that disabling cookies may affect website functionality.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">4. Changes</h2>
            <p>We may update this Cookie Policy periodically. Changes will be posted on this page with an updated date.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">5. Contact</h2>
            <div className="bg-white/5 rounded-xl p-6 border border-white/10">
              <p className="text-white font-semibold">Riven Byte Studios</p>
              <p className="text-sm mt-2">Email: <a href="mailto:hello@rivenbyte.com" className="text-primary-400">hello@rivenbyte.com</a></p>
            </div>
          </section>

        </div>
      </div>
    </div>
  );
};

export default CookiePolicyPage;
